import { render } from "./App.vue?vue&type=template&id=8e90fee6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8e90fee6&lang=scss"

import exportComponent from "/Users/gabrielvoissiere/Documents/Developpement/Developpement prs/npm package/simply_wave_demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__